const color_1 = '#7bbdc5'
const color_2 = '#cd3a6b'
const color_3 = '#f7e1e3'
const color_4 = 'gray'
const color_5 = '#8a96ea'
const color_6 = '#DE7878'
const color_7 = '#5fcc2d'
const color_8 = 'orange'
const color_9= '#01ACD2'
const color_10= '#EBEBEB'

const styles = {
    tc1: color_1, 
    tc2: color_2,
    tc3: color_5,

    bc1: color_1, 
    bc2: color_2,
    bc3: color_3, 
    bc4: color_4, 
    bc6: color_6, 
    bc7: color_7,
    bc8: color_8,
    bc9: color_9,
    bc10: color_10,
}

export default styles 